// extracted by mini-css-extract-plugin
export default {"list":"language-change_list__+S0bJ","listItem":"language-change_listItem__-ZhRq","btn":"language-change_btn__4EVGH","active":"language-change_active__w7fft"};